
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    const addedRoutes = router.getRoutes().filter(r => !r._initial)
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      for (const route of router.getRoutes()) {
        route._initial = true
      }
      for (const route of addedRoutes) {
        router.addRoute(route)
      }
      router.isReady().then(() => {
        // Resolve the current path against the new routes to get updated meta
        const newRoute = router.resolve(router.currentRoute.value.fullPath)
        // Clear old meta values and assign new ones
        for (const key of Object.keys(router.currentRoute.value.meta)) {
          delete router.currentRoute.value.meta[key]
        }
        Object.assign(router.currentRoute.value.meta, newRoute.meta)
      })
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
    for (const route of _router.getRoutes()) {
      route._initial = true
    }
  }
}
import { default as indexQScl7DZx8HQHyjzuSbj9kI1_LT5Jh2S4UrS0GDKKlMEMeta } from "/home/forge/bema.farbcode.net/releases/75292866/client/pages/index.vue?macro=true";
import { default as userBaseData4L5a24j_45DJuywk70ZvPAVpt9FnmtmquPaX3Fl4ZwtJUMeta } from "/home/forge/bema.farbcode.net/releases/75292866/client/pages/users/[id]/userBaseData.vue?macro=true";
import { default as userActivitiesDZDM8eOP1b9Aqj93ieL_KXl93kyfGUlpo3R7P4lkS_458Meta } from "/home/forge/bema.farbcode.net/releases/75292866/client/pages/users/[id]/userActivities.vue?macro=true";
import { default as userCommunicationsSgZo4VzI6yzkuscTjqppyBBBFn5650NJ7KiZWw_45szvUMeta } from "/home/forge/bema.farbcode.net/releases/75292866/client/pages/users/[id]/userCommunications.vue?macro=true";
import { default as _91id_93ZJ1YkmCPYxJr5_LqryuUgbtb_45zGq1h_1HbDAmuI1oToMeta } from "/home/forge/bema.farbcode.net/releases/75292866/client/pages/users/[id].vue?macro=true";
import { default as index_45gBmmalfWQfAmiw4nIz4LSYdLkBnjKrwn83y0N_456XOkMeta } from "/home/forge/bema.farbcode.net/releases/75292866/client/pages/users/index.vue?macro=true";
import { default as users7WtIotemEfJ2XpnunMHEnp_45lqMtHBxTR_NzdN69kGTEMeta } from "/home/forge/bema.farbcode.net/releases/75292866/client/pages/users.vue?macro=true";
import { default as companyBaseDatauTI7OjMnAx9vW9uV5U1xQSVFuh2eEjpiUWH56o1It5EMeta } from "/home/forge/bema.farbcode.net/releases/75292866/client/pages/company/companyBaseData.vue?macro=true";
import { default as companyrkaHmQbimc9d_1P8XYqvH7lwNAolaopkPfuzJyNbFb8Meta } from "/home/forge/bema.farbcode.net/releases/75292866/client/pages/company.vue?macro=true";
import { default as _91id_93JMN6X78yc9ze3k1LgDg7KbR52a1Ms4RMng13gDKjwTsMeta } from "/home/forge/bema.farbcode.net/releases/75292866/client/pages/baseData/categories/[id].vue?macro=true";
import { default as indexCTxZo6PgjZvn45sZI9RoT6NTmGJXOA5MiWCOsKL6KfwMeta } from "/home/forge/bema.farbcode.net/releases/75292866/client/pages/baseData/categories/index.vue?macro=true";
import { default as _91id_93UAKMDZU8A5y8B1JfrHynEtGdlBAyxlqRLlEP_4_go8IMeta } from "/home/forge/bema.farbcode.net/releases/75292866/client/pages/baseData/costCenters/[id].vue?macro=true";
import { default as index6_45rYmY4bIpzvxCN5ItsB_AnFk_jNIcfjUJz_MCMXA00Meta } from "/home/forge/bema.farbcode.net/releases/75292866/client/pages/baseData/costCenters/index.vue?macro=true";
import { default as baseDatar9SfWTMXgAU8QI4cceKowLrpoefvNmHNDMNTbbWmyIQMeta } from "/home/forge/bema.farbcode.net/releases/75292866/client/pages/baseData.vue?macro=true";
import { default as indexgaoqFro3ki4v6T_45hpHZqDL6I3fRDLWwO3uOcR_45fBwxUMeta } from "/home/forge/bema.farbcode.net/releases/75292866/client/pages/auth/index.vue?macro=true";
import { default as orderOffers43idRaLfYh830co5TrMnCf8pjPT3da5dBqNCZfzN3UMMeta } from "/home/forge/bema.farbcode.net/releases/75292866/client/pages/orders/[id]/orderOffers.vue?macro=true";
import { default as orderDetailsm2_EAjZddrlQysg5EscVhj387bpZsOwi7SLNyc8Wx_45QMeta } from "/home/forge/bema.farbcode.net/releases/75292866/client/pages/orders/[id]/orderDetails.vue?macro=true";
import { default as orderHistory_VAW2uM0FmSDrueMBiAN4XpPGl12G1NudS9K4KQe9toMeta } from "/home/forge/bema.farbcode.net/releases/75292866/client/pages/orders/[id]/orderHistory.vue?macro=true";
import { default as orderBaseDataD6edbJq2Dnb3SjnA1z3NrxO3RyyhT8CfpjFb5rMBfgoMeta } from "/home/forge/bema.farbcode.net/releases/75292866/client/pages/orders/[id]/orderBaseData.vue?macro=true";
import { default as _91id_935YZeciam_45A9Xh_or_45tsRHo5Nsn6XP_Wlj4WQMxIHaEsMeta } from "/home/forge/bema.farbcode.net/releases/75292866/client/pages/orders/[id].vue?macro=true";
import { default as indexjVpci0wpmrtKkNSg1cd_45Ct_45rxgGHFltVDo_45_za68vYIMeta } from "/home/forge/bema.farbcode.net/releases/75292866/client/pages/orders/index.vue?macro=true";
import { default as inputs1mhm852vJ7HtiNpCDRNx1GYFnGuZTL_450FtMmRgaxu2gMeta } from "/home/forge/bema.farbcode.net/releases/75292866/client/pages/secret/index/inputs.vue?macro=true";
import { default as dungeonjMK9_45iNTL60J8t9piDMJm_gEp2KZyGNV14nDyq0M16AMeta } from "/home/forge/bema.farbcode.net/releases/75292866/client/pages/secret/index/dungeon.vue?macro=true";
import { default as indexe1iOXMAkrPGFk4_45_K9v_414dcwau2uaX0XiHYHraaHwMeta } from "/home/forge/bema.farbcode.net/releases/75292866/client/pages/secret/index.vue?macro=true";
import { default as tenderBaseDatajtfzJNXXZ0_aI3_tegiDp934dkuwZWIRZKSIcZXbvywMeta } from "/home/forge/bema.farbcode.net/releases/75292866/client/pages/tenders/[id]/tenderBaseData.vue?macro=true";
import { default as _91id_93VZdnnzSNmc_fxlLbg_6fqVnUo5qqx25_4520Oy7qs5cVQMeta } from "/home/forge/bema.farbcode.net/releases/75292866/client/pages/tenders/[id].vue?macro=true";
import { default as organisationBaseDatahtk2YWRMONox5M2wQ2_PHOuR4uZp4u4R8FDLlXnSDcYMeta } from "/home/forge/bema.farbcode.net/releases/75292866/client/pages/organisations/[id]/organisationBaseData.vue?macro=true";
import { default as _91id_93QwvpDK2nQt99xiMe5S5kicylZzMImLnAECUYlsu8E7UMeta } from "/home/forge/bema.farbcode.net/releases/75292866/client/pages/organisations/[id].vue?macro=true";
import { default as indexuBeiwvGU1JlH3F3qcZXpl1LFqbI1B8wZtepJKYY6_45CAMeta } from "/home/forge/bema.farbcode.net/releases/75292866/client/pages/organisations/index.vue?macro=true";
import { default as organisationsvq48uHG_45_w_H49XtWvZJuc3VF7KHF6OxgBi9HJHUHCoMeta } from "/home/forge/bema.farbcode.net/releases/75292866/client/pages/organisations.vue?macro=true";
import { default as indexUJidA7niZHZPkIRIHbChsnR1znNZ8ybbtCEezOCLLy4Meta } from "/home/forge/bema.farbcode.net/releases/75292866/client/pages/tenders/index.vue?macro=true";
import { default as languageWs2fihhye5NOH5PPYJ_OBBmNNpnIOa8uceB6dBvZfrQMeta } from "/home/forge/bema.farbcode.net/releases/75292866/client/pages/settings/language.vue?macro=true";
import { default as indexEkrR8KIPQsx5azTxtKnFPfxWakPl4Gjy_45kE4FRCMDKAMeta } from "/home/forge/bema.farbcode.net/releases/75292866/client/pages/auth/company/index.vue?macro=true";
import { default as indexFRoQp_OtlT422BPgaEDfAaePiTl8vJa8LojavlwLtoEMeta } from "/home/forge/bema.farbcode.net/releases/75292866/client/pages/auth/social/[provider]/index.vue?macro=true";
import { default as _91id_93Q2ZxUmNseanVQ5o5YLl3wMG8fwDxpiF41BKYEygLwWEMeta } from "/home/forge/bema.farbcode.net/releases/75292866/client/pages/settings/loginProviders/[id].vue?macro=true";
import { default as indexl9bGquaQIGSeC6F_H92v74s_grrTpXYLW1zowriRHy4Meta } from "/home/forge/bema.farbcode.net/releases/75292866/client/pages/settings/mailTemplates/index.vue?macro=true";
import { default as indexV7RbqdoLtWYrSkNgThcjIfHnhU_mZzcmV9Fo3xxeMxYMeta } from "/home/forge/bema.farbcode.net/releases/75292866/client/pages/settings/loginProviders/index.vue?macro=true";
import { default as _91_46_46_46slug_93yq7zWvAovs7t5kbTnxT9CyRg4LXLpxeUbUaFTRwuwy0Meta } from "/home/forge/bema.farbcode.net/releases/75292866/client/pages/settings/mailTemplates/[name]/[...slug].vue?macro=true";
export default [
  {
    name: "index",
    path: "/",
    component: () => import("/home/forge/bema.farbcode.net/releases/75292866/client/pages/index.vue")
  },
  {
    name: users7WtIotemEfJ2XpnunMHEnp_45lqMtHBxTR_NzdN69kGTEMeta?.name,
    path: "/users",
    meta: users7WtIotemEfJ2XpnunMHEnp_45lqMtHBxTR_NzdN69kGTEMeta || {},
    component: () => import("/home/forge/bema.farbcode.net/releases/75292866/client/pages/users.vue"),
    children: [
  {
    name: "users-id",
    path: ":id()",
    meta: { ...(_91id_93ZJ1YkmCPYxJr5_LqryuUgbtb_45zGq1h_1HbDAmuI1oToMeta || {}), ...{"middleware":["can-access-route"]} },
    component: () => import("/home/forge/bema.farbcode.net/releases/75292866/client/pages/users/[id].vue"),
    children: [
  {
    name: "users-id-userBaseData",
    path: "userBaseData",
    component: () => import("/home/forge/bema.farbcode.net/releases/75292866/client/pages/users/[id]/userBaseData.vue")
  },
  {
    name: "users-id-userActivities",
    path: "userActivities",
    component: () => import("/home/forge/bema.farbcode.net/releases/75292866/client/pages/users/[id]/userActivities.vue")
  },
  {
    name: "users-id-userCommunications",
    path: "userCommunications",
    component: () => import("/home/forge/bema.farbcode.net/releases/75292866/client/pages/users/[id]/userCommunications.vue")
  }
]
  },
  {
    name: "users",
    path: "",
    meta: { ...(index_45gBmmalfWQfAmiw4nIz4LSYdLkBnjKrwn83y0N_456XOkMeta || {}), ...{"middleware":["can-access-route"]} },
    component: () => import("/home/forge/bema.farbcode.net/releases/75292866/client/pages/users/index.vue")
  }
]
  },
  {
    name: "company",
    path: "/company",
    meta: { ...(companyrkaHmQbimc9d_1P8XYqvH7lwNAolaopkPfuzJyNbFb8Meta || {}), ...{"middleware":["can-access-route"]} },
    component: () => import("/home/forge/bema.farbcode.net/releases/75292866/client/pages/company.vue"),
    children: [
  {
    name: "company-companyBaseData",
    path: "companyBaseData",
    component: () => import("/home/forge/bema.farbcode.net/releases/75292866/client/pages/company/companyBaseData.vue")
  }
]
  },
  {
    name: "baseData",
    path: "/baseData",
    meta: baseDatar9SfWTMXgAU8QI4cceKowLrpoefvNmHNDMNTbbWmyIQMeta || {},
    component: () => import("/home/forge/bema.farbcode.net/releases/75292866/client/pages/baseData.vue"),
    children: [
  {
    name: "baseData-categories-id",
    path: "categories/:id()",
    meta: { ...(_91id_93JMN6X78yc9ze3k1LgDg7KbR52a1Ms4RMng13gDKjwTsMeta || {}), ...{"middleware":["can-access-route"]} },
    component: () => import("/home/forge/bema.farbcode.net/releases/75292866/client/pages/baseData/categories/[id].vue")
  },
  {
    name: "baseData-categories",
    path: "categories",
    meta: { ...(indexCTxZo6PgjZvn45sZI9RoT6NTmGJXOA5MiWCOsKL6KfwMeta || {}), ...{"middleware":["can-access-route"]} },
    component: () => import("/home/forge/bema.farbcode.net/releases/75292866/client/pages/baseData/categories/index.vue")
  },
  {
    name: "baseData-costCenters-id",
    path: "costCenters/:id()",
    meta: { ...(_91id_93UAKMDZU8A5y8B1JfrHynEtGdlBAyxlqRLlEP_4_go8IMeta || {}), ...{"middleware":["can-access-route"]} },
    component: () => import("/home/forge/bema.farbcode.net/releases/75292866/client/pages/baseData/costCenters/[id].vue")
  },
  {
    name: "baseData-costCenters",
    path: "costCenters",
    meta: { ...(index6_45rYmY4bIpzvxCN5ItsB_AnFk_jNIcfjUJz_MCMXA00Meta || {}), ...{"middleware":["can-access-route"]} },
    component: () => import("/home/forge/bema.farbcode.net/releases/75292866/client/pages/baseData/costCenters/index.vue")
  }
]
  },
  {
    name: "auth",
    path: "/auth",
    meta: indexgaoqFro3ki4v6T_45hpHZqDL6I3fRDLWwO3uOcR_45fBwxUMeta || {},
    component: () => import("/home/forge/bema.farbcode.net/releases/75292866/client/pages/auth/index.vue")
  },
  {
    name: "orders-id",
    path: "/orders/:id()",
    meta: { ...(_91id_935YZeciam_45A9Xh_or_45tsRHo5Nsn6XP_Wlj4WQMxIHaEsMeta || {}), ...{"middleware":["can-access-route"]} },
    component: () => import("/home/forge/bema.farbcode.net/releases/75292866/client/pages/orders/[id].vue"),
    children: [
  {
    name: "orders-id-orderOffers",
    path: "orderOffers",
    component: () => import("/home/forge/bema.farbcode.net/releases/75292866/client/pages/orders/[id]/orderOffers.vue")
  },
  {
    name: "orders-id-orderDetails",
    path: "orderDetails",
    component: () => import("/home/forge/bema.farbcode.net/releases/75292866/client/pages/orders/[id]/orderDetails.vue")
  },
  {
    name: "orders-id-orderHistory",
    path: "orderHistory",
    component: () => import("/home/forge/bema.farbcode.net/releases/75292866/client/pages/orders/[id]/orderHistory.vue")
  },
  {
    name: "orders-id-orderBaseData",
    path: "orderBaseData",
    component: () => import("/home/forge/bema.farbcode.net/releases/75292866/client/pages/orders/[id]/orderBaseData.vue")
  }
]
  },
  {
    name: "orders",
    path: "/orders",
    meta: { ...(indexjVpci0wpmrtKkNSg1cd_45Ct_45rxgGHFltVDo_45_za68vYIMeta || {}), ...{"middleware":["can-access-route"]} },
    component: () => import("/home/forge/bema.farbcode.net/releases/75292866/client/pages/orders/index.vue")
  },
  {
    name: "secret",
    path: "/secret",
    component: () => import("/home/forge/bema.farbcode.net/releases/75292866/client/pages/secret/index.vue"),
    children: [
  {
    name: "secret-index-inputs",
    path: "inputs",
    component: () => import("/home/forge/bema.farbcode.net/releases/75292866/client/pages/secret/index/inputs.vue")
  },
  {
    name: "secret-index-dungeon",
    path: "dungeon",
    component: () => import("/home/forge/bema.farbcode.net/releases/75292866/client/pages/secret/index/dungeon.vue")
  }
]
  },
  {
    name: "tenders-id",
    path: "/tenders/:id()",
    meta: { ...(_91id_93VZdnnzSNmc_fxlLbg_6fqVnUo5qqx25_4520Oy7qs5cVQMeta || {}), ...{"middleware":["can-access-route"]} },
    component: () => import("/home/forge/bema.farbcode.net/releases/75292866/client/pages/tenders/[id].vue"),
    children: [
  {
    name: "tenders-id-tenderBaseData",
    path: "tenderBaseData",
    component: () => import("/home/forge/bema.farbcode.net/releases/75292866/client/pages/tenders/[id]/tenderBaseData.vue")
  }
]
  },
  {
    name: organisationsvq48uHG_45_w_H49XtWvZJuc3VF7KHF6OxgBi9HJHUHCoMeta?.name,
    path: "/organisations",
    meta: organisationsvq48uHG_45_w_H49XtWvZJuc3VF7KHF6OxgBi9HJHUHCoMeta || {},
    component: () => import("/home/forge/bema.farbcode.net/releases/75292866/client/pages/organisations.vue"),
    children: [
  {
    name: "organisations-id",
    path: ":id()",
    meta: { ...(_91id_93QwvpDK2nQt99xiMe5S5kicylZzMImLnAECUYlsu8E7UMeta || {}), ...{"middleware":["can-access-route"]} },
    component: () => import("/home/forge/bema.farbcode.net/releases/75292866/client/pages/organisations/[id].vue"),
    children: [
  {
    name: "organisations-id-organisationBaseData",
    path: "organisationBaseData",
    component: () => import("/home/forge/bema.farbcode.net/releases/75292866/client/pages/organisations/[id]/organisationBaseData.vue")
  }
]
  },
  {
    name: "organisations",
    path: "",
    meta: { ...(indexuBeiwvGU1JlH3F3qcZXpl1LFqbI1B8wZtepJKYY6_45CAMeta || {}), ...{"middleware":["can-access-route"]} },
    component: () => import("/home/forge/bema.farbcode.net/releases/75292866/client/pages/organisations/index.vue")
  }
]
  },
  {
    name: "tenders",
    path: "/tenders",
    meta: { ...(indexUJidA7niZHZPkIRIHbChsnR1znNZ8ybbtCEezOCLLy4Meta || {}), ...{"middleware":["can-access-route"]} },
    component: () => import("/home/forge/bema.farbcode.net/releases/75292866/client/pages/tenders/index.vue")
  },
  {
    name: "settings-language",
    path: "/settings/language",
    component: () => import("/home/forge/bema.farbcode.net/releases/75292866/client/pages/settings/language.vue")
  },
  {
    name: "auth-company",
    path: "/auth/company",
    meta: indexEkrR8KIPQsx5azTxtKnFPfxWakPl4Gjy_45kE4FRCMDKAMeta || {},
    component: () => import("/home/forge/bema.farbcode.net/releases/75292866/client/pages/auth/company/index.vue")
  },
  {
    name: "auth-social-provider",
    path: "/auth/social/:provider()",
    meta: indexFRoQp_OtlT422BPgaEDfAaePiTl8vJa8LojavlwLtoEMeta || {},
    component: () => import("/home/forge/bema.farbcode.net/releases/75292866/client/pages/auth/social/[provider]/index.vue")
  },
  {
    name: "settings-loginProviders-id",
    path: "/settings/loginProviders/:id()",
    meta: { ...(_91id_93Q2ZxUmNseanVQ5o5YLl3wMG8fwDxpiF41BKYEygLwWEMeta || {}), ...{"middleware":["can-access-route"]} },
    component: () => import("/home/forge/bema.farbcode.net/releases/75292866/client/pages/settings/loginProviders/[id].vue")
  },
  {
    name: "settings-mailTemplates",
    path: "/settings/mailTemplates",
    meta: { ...(indexl9bGquaQIGSeC6F_H92v74s_grrTpXYLW1zowriRHy4Meta || {}), ...{"middleware":["can-access-route"]} },
    component: () => import("/home/forge/bema.farbcode.net/releases/75292866/client/pages/settings/mailTemplates/index.vue")
  },
  {
    name: "settings-loginProviders",
    path: "/settings/loginProviders",
    meta: { ...(indexV7RbqdoLtWYrSkNgThcjIfHnhU_mZzcmV9Fo3xxeMxYMeta || {}), ...{"middleware":["can-access-route"]} },
    component: () => import("/home/forge/bema.farbcode.net/releases/75292866/client/pages/settings/loginProviders/index.vue")
  },
  {
    name: "settings-mailTemplates-name-slug",
    path: "/settings/mailTemplates/:name()/:slug(.*)*",
    meta: { ...(_91_46_46_46slug_93yq7zWvAovs7t5kbTnxT9CyRg4LXLpxeUbUaFTRwuwy0Meta || {}), ...{"middleware":["can-access-route"]} },
    component: () => import("/home/forge/bema.farbcode.net/releases/75292866/client/pages/settings/mailTemplates/[name]/[...slug].vue")
  }
]